import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { makeStyles, createStyles, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { g as globalButtonStyles } from './globalButtonStyles-41c8af84.js';

var getTypeColor = function (type) {
    switch (type) {
        case PromptType.Info:
            return '#03A9F4';
        case PromptType.Warning:
            return '#D6A20D';
        case PromptType.Error:
            return '#D60D2C';
        default:
            return 'inherit';
    }
};
var usePromptStyles = makeStyles(function (theme) {
    return createStyles({
        title: {
            display: 'flex',
            alignItems: 'center'
        },
        titleLabel: {
            fontWeight: 700
        },
        typeIcon: {
            color: function (props) {
                return props.color;
            }
        },
        typeLabel: {
            marginRight: '10px',
            fontWeight: 700,
            color: function (props) {
                return props.color;
            }
        }
    });
});
var PromptType;
(function (PromptType) {
    PromptType[PromptType["Info"] = 1] = "Info";
    PromptType[PromptType["Warning"] = 2] = "Warning";
    PromptType[PromptType["Error"] = 3] = "Error";
})(PromptType || (PromptType = {}));
var Prompt = function (props) {
    var title = props.title,
        type = props.type,
        content = props.content,
        confirmLabel = props.confirmLabel,
        cancelLabel = props.cancelLabel,
        onConfirm = props.onConfirm,
        onClose = props.onClose,
        confirmDisabled = props.confirmDisabled,
        hideIcon = props.hideIcon;
    var btnClasses = globalButtonStyles();
    var styles = usePromptStyles({ color: getTypeColor(type) });
    var renderTypeLabel = function (type) {
        switch (type) {
            case PromptType.Info:
                return jsxs(Fragment, { children: [!hideIcon && jsx(InfoIcon, { className: styles.typeIcon }), jsx(Typography, { variant: "h6", classes: { root: styles.typeLabel }, children: "Info:" })] });
            case PromptType.Warning:
                return jsxs(Fragment, { children: [!hideIcon && jsx(WarningIcon, { className: styles.typeIcon }), jsx(Typography, { variant: "h6", classes: { root: styles.typeLabel }, children: "Warning:" })] });
            case PromptType.Error:
                return jsxs(Fragment, { children: [!hideIcon && jsx(ErrorIcon, { className: styles.typeIcon }), jsx(Typography, { variant: "h6", classes: { root: styles.typeLabel }, children: "Error:" })] });
            default:
                return jsx(Fragment, {});
        }
    };
    var titleComponent = jsxs("div", { className: styles.title, children: [renderTypeLabel(type), jsx(Typography, { variant: "h6", classes: { root: styles.titleLabel }, children: title })] });
    var actionsComponent = jsx(Fragment, { children: onConfirm ? jsxs(Fragment, { children: [jsx(Button, { className: "".concat(btnClasses.btn, " ").concat(btnClasses.filled, " "), onClick: onConfirm, disabled: confirmDisabled, children: confirmLabel ? confirmLabel : 'Ok' }), jsx(Button, { className: "".concat(btnClasses.btn, " ").concat(btnClasses.inactive), onClick: onClose, children: cancelLabel ? cancelLabel : 'Cancel' })] }) : jsx(Button, { className: "".concat(btnClasses.btn, " ").concat(btnClasses.filled), onClick: onClose, children: confirmLabel ? confirmLabel : 'Ok' }) });
    return jsxs(Dialog, { "aria-labelledby": "customized-dialog-title", open: true, children: [jsx(DialogTitle, { disableTypography: true, children: titleComponent }), jsx(DialogContent, { dividers: true, children: content }), jsx(DialogActions, { children: actionsComponent })] });
};

export { PromptType as P, Prompt as a };
